import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'anihis-discharge-epicrisis',
  templateUrl: './discharge-epicrisis.component.html',
  styleUrls: ['./discharge-epicrisis.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DischargeEpicrisisComponent {
  @Output() formChange = new EventEmitter<any>();

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      patientHistory: new FormControl(''),
      findingsAndTherapy: new FormControl(''),
      notes: new FormControl(''),
      veterinarianName: new FormControl(''),
    });

    this.form.valueChanges.subscribe((value) => this.formChange.emit(value));
  }

  get patientHistory(): FormControl {
    return this.form.get('patientHistory') as FormControl;
  }

  get findingsAndTherapy(): FormControl {
    return this.form.get('findingsAndTherapy') as FormControl;
  }

  get notes(): FormControl {
    return this.form.get('notes') as FormControl;
  }

  get veterinarianName(): FormControl {
    return this.form.get('veterinarianName') as FormControl;
  }

  clearForm() {
    this.form.reset();
  }
}
